// extracted by mini-css-extract-plugin
export default {"screenreaderOnly":"accessibility_screenreaderOnly__OEzRB"};